<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Network Settings">Network Settings</span>
      </div>
      <div class="app-toolbar-end">
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="networksettings"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <div class="settings-container">

          <mat-accordion multi="true" displayMode="flat">

            <!-- Section: Default Carrier Service Maps -->
            <mat-expansion-panel (opened)="onCarrierMapPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">local_shipping</mat-icon>
                  <span i18n="@@Default Carrier Service Maps">Default Carrier Service Maps</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionDefaultCarrierServiceMaps">Manage the default carrier service code mappings for each ecommerce connection type. These defaults are used when an organization has not customized their own carrier service map.</div>

              <div *ngIf="carrierServiceMapLoading" style="display: flex; align-items: center; gap: 8px; padding: 16px 0;">
                <mat-spinner diameter="24"></mat-spinner>
                <span i18n="@@Loading data">Loading data</span>
              </div>

              <div *ngIf="!carrierServiceMapLoading && carrierServiceMapLoaded">
                <!-- One sub-panel per ecommerce type -->
                <mat-accordion multi="true" displayMode="flat">
                  <mat-expansion-panel *ngFor="let ecType of ecommerceTypes" [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon class="section-icon">store</mat-icon>
                        <span>{{ecType.type | languageString}}</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="type-panel-description">
                      <mat-icon>info_outline</mat-icon>
                      <span class="settings-description"><span i18n="@@defaultMappingsForType">Default carrier service code mappings for</span>&nbsp;<strong>{{ecType.type | languageString}}</strong>&nbsp;(<span i18n="@@map Id">map Id</span>: {{ecType.mapId}})</span>
                    </div>

                    <!-- Mappings table -->
                    <table class="carrier-map-table" *ngIf="getMappings(ecType.type).length > 0">
                      <thead>
                        <tr>
                          <th i18n="@@Ecommerce Carrier Code">Ecommerce Carrier Code</th>
                          <th i18n="@@Carrier Service">Carrier Service</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let mapping of getMappings(ecType.type); let i = index">
                          <td>
                            <mat-form-field appearance="outline" class="full-width carrier-map-field">
                              <input matInput [(ngModel)]="mapping.customerCarrierService" [name]="'custCode_' + ecType.type + '_' + i"
                                     (ngModelChange)="markMappingDirty(mapping)">
                            </mat-form-field>
                            <div *ngIf="isDuplicateCustomerCode(ecType.type, mapping)" class="carrier-map-error" i18n="@@Duplicate carrier code">Duplicate carrier code</div>
                          </td>
                          <td>
                            <mat-form-field appearance="outline" class="full-width carrier-map-field">
                              <mat-select [(ngModel)]="mapping.carrierService" [name]="'svcLevel_' + ecType.type + '_' + i"
                                          (ngModelChange)="markMappingDirty(mapping)">
                                <mat-option *ngFor="let cs of carrierServiceLevels" [value]="cs.ID">{{cs.carrier}} — {{cs.serviceLevel}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td class="carrier-map-actions">
                            <button mat-icon-button color="warn" (click)="deleteMapping(ecType.type, mapping)" i18n-title="destructive removal|Button that permanently destroys the record. Must be clearly different from Cancel, which only closes a dialog.@@Delete" title="Delete">
                              <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" *ngIf="dirtyMappings.has(mapping)"
                                    [disabled]="!mapping.customerCarrierService || isDuplicateCustomerCode(ecType.type, mapping)"
                                    (click)="saveMapping(mapping)" i18n-title="@@Save" title="Save">
                              <mat-icon>save</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="carrier-map-button-bar">
                      <button mat-raised-button color="primary" (click)="addMapping(ecType.type)" i18n="@@Add Mapping">Add Mapping</button>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </mat-expansion-panel>

            <!-- Section: Service Provider Rate Configurations -->
            <mat-expansion-panel (opened)="onRateConfigPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">tune</mat-icon>
                  <span i18n="@@Service Provider Rate Configurations">Service Provider Rate Configurations</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionSpRateConfigs">Edit the authoritative shipping/handling rate configuration for each service provider, plus the rate configuration that the network charges that service provider.</div>

              <div class="rate-config-picker">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label i18n="@@Service Provider">Service Provider</mat-label>
                  <mat-select [ngModel]="selectedServiceProvider" (ngModelChange)="selectServiceProvider($event)" name="rcSpPicker">
                    <mat-option *ngFor="let sp of serviceProviders" [value]="sp">{{sp.Name}} ({{sp.ID}})</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-button-toggle-group [value]="selectedSpProperty" (change)="selectSpProperty($event.value)" *ngIf="selectedServiceProvider">
                  <mat-button-toggle value="rateConfig" i18n="@@SP rateConfig">Authoritative shipping rates</mat-button-toggle>
                  <mat-button-toggle value="serviceProviderChargedRateConfig" i18n="@@SP chargedRateConfig">Shipping rates charged by network</mat-button-toggle>
                </mat-button-toggle-group>
              </div>

              <ng-container *ngIf="selectedServiceProvider">
                <app-rate-config-editor
                  subjectKind="serviceProvider"
                  [subjectId]="selectedServiceProvider.ID"
                  [documentProperty]="selectedSpProperty"
                  editorMode="AUTHORITATIVE">
                </app-rate-config-editor>
              </ng-container>
            </mat-expansion-panel>

            <!-- Section: Service Provider Packing Rate Configurations -->
            <mat-expansion-panel (opened)="onRateConfigPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">inventory_2</mat-icon>
                  <span i18n="@@Service Provider Packing Rate Configurations">Service Provider Packing Rate Configurations</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionSpPackingRateConfigs">Edit the picking, packing and packaging rate configuration for each service provider, plus the packing rate configuration that the network charges that service provider. Same document shape as the production rate configuration; only the inputs (per-package and per-order rather than per-book) differ.</div>

              <div class="rate-config-picker">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label i18n="@@Service Provider">Service Provider</mat-label>
                  <mat-select [ngModel]="selectedServiceProviderPacking" (ngModelChange)="selectServiceProviderPacking($event)" name="rcSpPickerPacking">
                    <mat-option *ngFor="let sp of serviceProviders" [value]="sp">{{sp.Name}} ({{sp.ID}})</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-button-toggle-group [value]="selectedSpPackingProperty" (change)="selectSpPackingProperty($event.value)" *ngIf="selectedServiceProviderPacking">
                  <mat-button-toggle value="packingRateConfig" i18n="@@SP packingRateConfig">Authoritative packing rates</mat-button-toggle>
                  <mat-button-toggle value="serviceProviderChargedPackingRateConfig" i18n="@@SP chargedPackingRateConfig">Packing rates charged by network</mat-button-toggle>
                </mat-button-toggle-group>
              </div>

              <ng-container *ngIf="selectedServiceProviderPacking">
                <app-rate-config-editor
                  subjectKind="serviceProvider"
                  [subjectId]="selectedServiceProviderPacking.ID"
                  [documentProperty]="selectedSpPackingProperty"
                  editorMode="AUTHORITATIVE">
                </app-rate-config-editor>
              </ng-container>
            </mat-expansion-panel>

            <!-- Section: Facility Rate Configurations -->
            <mat-expansion-panel (opened)="onRateConfigPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">factory</mat-icon>
                  <span i18n="@@Facility Rate Configurations">Facility Rate Configurations</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionFacilityRateConfigs">Edit the rate configuration for each facility. Facilities are leaf nodes; their rate configuration is authoritative.</div>

              <div class="rate-config-picker">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label i18n="@@Facility">Facility</mat-label>
                  <mat-select [ngModel]="selectedFacility" (ngModelChange)="selectFacility($event)" name="rcFacilityPicker">
                    <mat-option *ngFor="let f of facilities" [value]="f">{{f.friendlyName || f.name}} ({{f.ID}})</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <ng-container *ngIf="selectedFacility">
                <app-rate-config-editor
                  subjectKind="facility"
                  [subjectId]="selectedFacility.ID"
                  documentProperty="rateConfig"
                  editorMode="AUTHORITATIVE">
                </app-rate-config-editor>
              </ng-container>
            </mat-expansion-panel>

            <!-- Section: Facility Packing Rate Configurations -->
            <mat-expansion-panel (opened)="onRateConfigPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">inventory_2</mat-icon>
                  <span i18n="@@Facility Packing Rate Configurations">Facility Packing Rate Configurations</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionFacilityPackingRateConfigs">Edit the picking, packing and packaging rate configuration for each facility (what SnowfallPress pays the facility per packing operation). Same document shape as the production rate configuration.</div>

              <div class="rate-config-picker">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label i18n="@@Facility">Facility</mat-label>
                  <mat-select [ngModel]="selectedFacilityPacking" (ngModelChange)="selectFacilityPacking($event)" name="rcFacilityPickerPacking">
                    <mat-option *ngFor="let f of facilities" [value]="f">{{f.friendlyName || f.name}} ({{f.ID}})</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <ng-container *ngIf="selectedFacilityPacking">
                <app-rate-config-editor
                  subjectKind="facility"
                  [subjectId]="selectedFacilityPacking.ID"
                  documentProperty="packingRateConfig"
                  editorMode="AUTHORITATIVE">
                </app-rate-config-editor>
              </ng-container>
            </mat-expansion-panel>

            <!-- Section: Sales Tax (per-ServiceProvider) -->
            <mat-expansion-panel (opened)="onSalesTaxPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">receipt_long</mat-icon>
                  <span i18n="@@Sales Tax">Sales Tax</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionNetworkSalesTax">Select an active ServiceProvider, then manage its nexus states, reciprocity sets for `other` and `wholesale` exemption types, and review pending exemption requests submitted by organizations under this ServiceProvider.</div>

              <!-- SP picker -->
              <div class="picker-row">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Service Provider">Service Provider</mat-label>
                  <mat-select [value]="salesTaxSelectedSp" (selectionChange)="selectSalesTaxSp($event.value)">
                    <mat-option *ngFor="let sp of serviceProviders" [value]="sp">{{sp.Name}} ({{sp.ID}})</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <ng-container *ngIf="salesTaxSelectedSp">
                <!-- Nexus & Reciprocity editor -->
                <mat-card appearance="outlined" class="stx-card">
                  <mat-card-title i18n="@@Nexus and Reciprocity">Nexus and Reciprocity</mat-card-title>
                  <mat-card-content>
                    <div *ngIf="salesTaxConfigLoading" style="display: flex; align-items: center; gap: 8px; padding: 8px 0;">
                      <mat-spinner diameter="20"></mat-spinner>
                      <span i18n="@@Loading data">Loading data</span>
                    </div>

                    <div class="stx-error" *ngIf="salesTaxConfigError">{{salesTaxConfigError}}</div>

                    <ng-container *ngIf="!salesTaxConfigLoading">
                      <h4 i18n="@@Nexus States">Nexus States</h4>
                      <div class="stx-help" i18n="@@helpNexusStates">States where this ServiceProvider collects sales tax. Organizations may request exemptions only for these states; other states are shown as no-nexus to operators.</div>
                      <app-sales-tax-states-matrix
                        [config]="salesTaxConfig"
                        mode="nexus"
                        [(selectedStates)]="stxNexusStates">
                      </app-sales-tax-states-matrix>

                      <h4 i18n="@@Reciprocity for Other">Reciprocity — Other</h4>
                      <div class="stx-help" i18n="@@helpReciprocityOther">States that accept another state's certificate as reciprocal evidence for non-profit / other exemptions. The org-side UI pre-checks these states when an issuing state has been entered.</div>
                      <app-sales-tax-states-matrix
                        [config]="salesTaxConfig"
                        mode="reciprocity"
                        [(selectedStates)]="stxReciprocityOther">
                      </app-sales-tax-states-matrix>

                      <h4 i18n="@@Reciprocity for Wholesale">Reciprocity — Wholesale</h4>
                      <div class="stx-help" i18n="@@helpReciprocityWholesale">States that accept another state's resale certificate as reciprocal evidence for wholesale exemptions.</div>
                      <app-sales-tax-states-matrix
                        [config]="salesTaxConfig"
                        mode="reciprocity"
                        [(selectedStates)]="stxReciprocityWholesale">
                      </app-sales-tax-states-matrix>

                      <div class="stx-actions">
                        <button mat-stroked-button color="primary"
                                [disabled]="salesTaxConfigSaving"
                                (click)="saveSalesTaxConfig()">
                          <span i18n="@@Save Sales Tax Configuration">Save Sales Tax Configuration</span>
                        </button>
                        <mat-spinner *ngIf="salesTaxConfigSaving" diameter="18"></mat-spinner>
                      </div>
                    </ng-container>
                  </mat-card-content>
                </mat-card>

                <!-- Review queue + detail (shared component, reused by SP-side host too) -->
                <app-sales-tax-review [serviceProviderId]="salesTaxSelectedSp.ID"></app-sales-tax-review>
              </ng-container>
            </mat-expansion-panel>

            <!-- Section: Payment Collection (CollectionProvider) -->
            <mat-expansion-panel (opened)="onCollectionProviderPanelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="section-icon">payments</mat-icon>
                  <span i18n="@@Payment Collection">Payment Collection</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="settings-description" i18n="@@descriptionCollectionProvider">Select a service provider, then edit the collection provider mapped by its collection provider Id. The payment settings hold the payment-processor routing values and CardPointe credentials used to charge orders under this service provider.</div>

              <div class="picker-row">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Service Provider">Service Provider</mat-label>
                  <mat-select [value]="collectionProviderSelectedSp" (selectionChange)="selectCollectionProviderSp($event.value)">
                    <mat-option *ngFor="let sp of serviceProviders" [value]="sp">{{sp.Name}} ({{sp.ID}})</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="cp-no-mapping" *ngIf="collectionProviderSelectedSp && !collectionProviderIdForSelectedSp">
                <mat-icon>warning</mat-icon>
                <span i18n="@@This ServiceProvider has no collectionprovider_ID set — nothing to edit.">This ServiceProvider has no collectionprovider_ID set — nothing to edit.</span>
              </div>

              <app-collection-provider-editor
                *ngIf="collectionProviderSelectedSp && collectionProviderIdForSelectedSp"
                [providerId]="collectionProviderIdForSelectedSp">
              </app-collection-provider-editor>
            </mat-expansion-panel>

          </mat-accordion>

        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>


